import { IListMenuWidget } from './menu-list.-widget';
import { EListViewType } from '@enums/index';
import { IListViewWidget } from './list-view';

export interface IListViewWidgetSave {
    data: IListViewWidget | IListMenuWidget | [];
    name: string;
    type: EListViewType;
}
